import ErrorFallback from 'Components/ErrorFallback'
import {
  ProductCreatePage,
  ProductEditPage,
  ProductListPage
} from 'Services/ProductManagement/Features/Product/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function ProductRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ProductListPage />} />
        <Route path="create" element={<ProductCreatePage />} />
        <Route path=":id/edit" element={<ProductEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default ProductRoot
